import {LuSearch  } from "@/Components/Icons/Icons";
export default {
  row1: [
    {
      column: "column1",
      columnWidth: "55%",
      rows: {
        row1: [
          {
            name: "importProductOtherdetailsPrevBENo",
            label: "Prev.B/E No",
            component: "text-field",
            width: "50%",
          },
          {
            name: "importProductOtherdetailsPrevBEDate",
            component: "DateSelector",
            width: "50%",
          },
        ],
        row2: [
          {
            name: "importProductOtherdetailsPrevIGMNo",
            label: "Prev.IGM No",
            component: "text-field",
            width: "50%",
          },
          {
            name: "importProductOtherdetailsPrevIGMDate",
            component: "DateSelector",
            width: "50%",
          },
        ],
        row3: [
          {
            name: "importProductOtherdetailsUnit",
            label: "Unit Value",
            component: "text-field",
            endpoint:"getQuantity",
            type:"autocomplete"
          },
          {
            name: "importProductOtherdetailsUnitValue",
            component: "text-field",
            dataType:"int"
          },
        ],
        row4: [
          {
            name: "importProductOtherdetailsCustomHouse",
            label: "Custom House",
            component: "text-field",
            icon:LuSearch ,
            type:"autocomplete",
            endpoint: "getCustomeHouse",

          },
        ],
        row5: [
          {
            name: "importProductOtherdetailsRemarks",
            actionText: "Remarks",
            component: "textarea",
            sx: {
              height: "75px",
              borderRadius: "7px",
            },
          },
        ],
      },
    },
  ],
};
